import React from 'react'
import Error500 from '../../Error/Error500'

function Error505() {
  return (
    <div>
      <Error500/>
    </div>
  )
}

export default Error505
